var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('mt-header',{attrs:{"title":_vm.title}},[_c('mt-button',{attrs:{"slot":"left","icon":"back"},on:{"click":_vm.closeqShop},slot:"left"},[_vm._v("返回")])],1),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('Common-Query')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dff652d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/commonQueryIndex.vue
// module id = null
// module chunks = 